/**
 * 공유. 카드 이미지는 아카이브에 올린 뒤 서버가 OG 로 만들어 주고,
 * 앱에서는 링크와 한 줄을 넘긴다.
 *
 * 사람은 AI 가 쓴 문장보다 자기가 쓴 문장을 공유한다 — 그래서 본문은
 * share.headline 과 본인 발언 인용(pull_quote)으로 만든다.
 */
export function shareText({ topic, stanceLabel, share }) {
  const head = share?.headline?.trim();
  const quote = share?.pull_quote?.trim();
  return [
    head ? `${head}` : `${topic} · ${stanceLabel}`,
    quote ? `\n"${quote}"` : null,
  ].filter(Boolean).join("");
}

/**
 * @returns {"shared"|"copied"|"failed"} 무엇이 일어났는지. 화면이 그대로 말해 준다.
 */
export async function shareOrCopy({ text, url }) {
  const payload = { title: "그래서요?", text, url };

  if (navigator.share) {
    try {
      await navigator.share(payload);
      return "shared";
    } catch (e) {
      // 사용자가 닫은 것은 실패가 아니다. 조용히 넘어간다.
      if (e?.name === "AbortError") return "shared";
    }
  }

  try {
    await navigator.clipboard.writeText(`${text}\n${url}`);
    return "copied";
  } catch {
    return "failed";
  }
}
